export default __webpack_public_path__ + "img/consultation_ps_1-64a6fa1a46c06a45e715df1a728fa502.png";